import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Container } from './styles'

function Chat() {
    const { channel, id } = useParams()
    const available = Boolean(channel && id)

    useEffect(() => {
        if (!available) return

        window._rt = {
            mode: 'full_screen',
            token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTM1NDAxLCJoYXNoIjoic0x6Z1N2ZmpGQjFwbEZLT25sMHJrOUtDY2NPVU9ROGciLCJkYiI6IlhFRjdBLVZaUzNELTJaUTg1LVRKS042IiwibGljZW5jZSI6IlhFRjdBLVZaUzNELTJaUTg1LVRKS042IiwiY2hhbm5lbCI6bnVsbCwiYXBwIjoicnVudGFzayIsImlhdCI6MTc5MDEwNDQ1N30.kDRPpNjgGs7vDj-bpr1AuclUr5Dm5XQ-HxleQjhaSGE',
            uri: 'api.azzas2154.runtask.com',
            sessionCode: id,
            contactChannel: channel,
        }

        const elem = document.createElement('script')
        elem.type = 'text/javascript'
        elem.async = true
        elem.src = 'https://cdn.runtask.com/static/js/chat.js'
        const chatDiv = document.getElementById('chat')
        chatDiv.appendChild(elem)

        return () => {
            chatDiv.removeChild(elem)
            delete window._rt
        }
    }, [available, channel, id])

    return (
        <Container>
            {available ? (
                <div
                    id="chat"
                    className="overflow-hidden w-full"
                    style={{ height: '100dvh' }}
                >
                    <div id="rt-chat" className="w-full h-full" />
                </div>
            ) : (
                <div className="overflow-auto w-full" style={{ flex: 1 }}>
                    Chat indisponível
                </div>
            )}
        </Container>
    )
}

export default Chat
